module.exports = __webpack_public_path__ + "img/haiti-logo-icon.c75b7be0.png";